import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { type AppInsightsPlugin } from '../services/AppInsightsPlugin';

export const useAppInsights = (): AppInsightsPlugin => {
  return useAppInsightsContext() as AppInsightsPlugin;
};
